export const MIGRATION_STEP_LABELS = {
  productTypeGroup: "Class Groups",
  productType: "Insurance Classes",
  provider: "Insurers",
  user: "Agents / Producers",
  client: "Clients",
  debitNote: "Policies (Debit Notes)",
};

export const MIGRATION_JOB_STATUSES = [
  "PROCESSING",
  "COMPLETED",
  "FAILED",
  "CANCELLED",
  "UNDOING",
  "UNDONE",
];

export const MIGRATION_ROW_STATUSES = [
  "success",
  "warning",
  "error",
  "cancelled",
  "skipped",
];

export const MIGRATION_TYPE_FILTER_OPTIONS = [
  { value: "all", label: "All types" },
  ...Object.entries(MIGRATION_STEP_LABELS).map(([value, label]) => ({
    value,
    label,
  })),
];

export const MIGRATION_STATUS_FILTER_OPTIONS = [
  { value: "all", label: "All statuses" },
  ...MIGRATION_JOB_STATUSES.map((status) => ({
    value: status,
    label: status,
  })),
];

export function canStopMigrationJob(batch) {
  return batch?.status === "PROCESSING";
}

export function canUndoMigrationJob(batch) {
  return (
    batch?.step === "debitNote" &&
    ["COMPLETED", "FAILED", "CANCELLED"].includes(batch?.status)
  );
}

const formatJobCount = (value) => Number(value || 0).toLocaleString("en-US");

export function formatMigrationJobProgress(batch) {
  if (!batch) return "";
  const phase = batch.stats?.currentPhase;
  const phaseLabel = batch.stats?.phaseLabel;
  const usePhaseCounts =
    Boolean(phase) && phase !== "import" && batch.stats?.phaseTotal != null;
  const processed = usePhaseCounts
    ? batch.stats.phaseProcessed ?? 0
    : batch.stats?.processedRows ?? 0;
  const total = usePhaseCounts
    ? batch.stats.phaseTotal ?? 0
    : batch.stats?.totalRows ?? 0;
  const counts = `${formatJobCount(processed)} / ${formatJobCount(total)}`;
  if (
    batch.status === "PROCESSING" &&
    !phase &&
    !phaseLabel &&
    total > 0 &&
    processed >= total
  ) {
    return "Finishing payments and commissions…";
  }
  return phaseLabel ? `${phaseLabel} ${counts}` : counts;
}

export function formatMigrationJobStatus(batch) {
  if (!batch?.status) return "";
  if (batch.status === "PROCESSING" || batch.status === "UNDOING") {
    return `${batch.status} ${formatMigrationJobProgress(batch)}`.trim();
  }
  return batch.status;
}

export function shouldPollMigrationJobs(batches = []) {
  return batches.some((batch) =>
    ["PROCESSING", "UNDOING"].includes(batch?.status)
  );
}

export function isStepImportLocked(batches = [], step) {
  return batches.some(
    (batch) => batch.step === step && batch.status === "PROCESSING"
  );
}

export function formatMigrationJobError(batch) {
  const logs = Array.isArray(batch?.errorLog) ? batch.errorLog : [];
  const errors = logs.filter(
    (entry) => entry?.message && entry.severity !== "warning"
  );
  const last = errors[errors.length - 1] || logs[logs.length - 1];
  return last?.message ? String(last.message) : "";
}

export function formatMigrationDate(value) {
  if (!value) return "-";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return date.toLocaleString();
}
